<div *ngIf="reportType == 'send-reminder1'">

  <button (click)="printPage()" class="no-print" mat-raised-button color="primary">
    Print
  </button>

   <!-- ⭐ ADD THIS: Bulk send button, outside the *ngFor loop -->
  <button (click)="sendAllWhatsAppReminders()" class="no-print" mat-raised-button color="accent"
    [disabled]="sendingAllWhatsApp || !letters.length" style="margin-left: 10px;">
    {{ sendingAllWhatsApp ? 'पाठवत आहे...' : 'सर्वांना WhatsApp पाठवा' }}
  </button>


  <div id="print-section">

    <!-- ⭐ LOOP EACH BOOKSELLER -->
    <div *ngFor="let letter of letters; let last = last" class="reminder-container">

           <button mat-raised-button class="no-print" [disabled]="letter.isSendingWhatsApp || letter.isWhatsAppSent"
        (click)="sendWhatsAppReminder(letter)">
        {{ letter.isWhatsAppSent ? 'पाठवले' : (letter.isSendingWhatsApp ? 'पाठवत आहे...' : 'WhatsApp पाठवा') }}
      </button>


      <div class="header-section">
        <div class="header-content">
          <div class="header-top">
            <div class="organization-info">
              <h1 class="organization-name">हिंदुस्थान प्रकाशन संस्था</h1>
              <span class="registration-number">(Reg.No.-BOM-3/1961(GBDSD))</span><br>
              <span class="office-label">प्रशासकीय कार्यालय:</span> 116-119, शिल्पीन सेंटर, पहिला मजला, 40,
              ग.द.
              आंबेकर मार्ग,<br><span class="contact-label"> वडाळा, मुंबई - 400031, दूरध्वनी:</span> 7506732905
            </div>
            <div class="header-logo">
              <img src="../../../assets/img/brand/book.png" alt="Logo" />
            </div>
          </div>
          <hr class="header-divider" />
          <div class="office-details-single">

            <!-- <span class="office-label">मुख्य कार्यालय:</span> 5/12, कामत औद्योगिक वसाहत, 396 स्वा. वीर सावरकर
                    मार्ग, प्रभादेवी, मुंबई 400025, <span class="contact-label">दूरध्वनी:</span> 24221440 -->
          </div>
        </div>
      </div>

      <!-- HEADER -->
      <h2 style="text-align:center;font-weight:bold;">ग्राहक स्मरणपत्र</h2>

      <div style="font-weight:bold;">
        <b>प्रति:</b> {{letter.booksellername}}<br>
        <b>जिल्हा:</b> {{letter.district}}<br>
        <!-- <b>दिनांक:</b> {{currentDate | date:'dd/MM/yyyy'}} -->
      </div>
      <div style="font-weight:bold;text-align:right;">
        <!-- <b>प्रति:</b> {{letter.booksellername}}<br>
        <b>जिल्हा:</b> {{letter.district}}<br> -->
        <b>दिनांक:</b> {{currentDate | date:'dd/MM/yyyy'}}
      </div>

      <hr>

      <div class="subject-line">
        <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.subject_line" rows="2" class="form-control"
          style="width: 100%; padding: 8px; font-weight: bold;">
                    </textarea>
        <span *ngIf="!isEditMode">{{letterBodyText.subject_line}}</span>
      </div>

      <!-- Greeting -->
      <div class="greeting" style="text-align: left;">
        <input *ngIf="isEditMode" type="text" [(ngModel)]="letterBodyText.greeting" class="form-control"
          style="width: 100%; padding: 8px;">
        <span *ngIf="!isEditMode">{{letterBodyText.greeting}}</span>
      </div>

      <!-- Letter Body -->
      <div class="letter-body">

        <!-- Paragraph 1 -->
        <div style="margin-bottom: 15px;">
          <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph1" rows="4" class="form-control"
            style="width: 100%; padding: 8px;">
                        </textarea>
          <p *ngIf="!isEditMode">{{letterBodyText.paragraph1}}</p>
        </div>

        <!-- Paragraph 2 -->
        <div style="margin-bottom: 15px;">
          <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph2" rows="1" class="form-control"
            style="width: 100%; padding: 8px;">
                        </textarea>
          <p *ngIf="!isEditMode">{{letterBodyText.paragraph2}}</p>
        </div>

        <!-- Paragraph 3 -->
        <div style="margin-bottom: 15px;">
          <textarea *ngIf="isEditMode" [(ngModel)]="letterBodyText.paragraph3" rows="6" class="form-control"
            style="width: 100%; padding: 8px;">
                        </textarea>
          <p *ngIf="!isEditMode">{{letterBodyText.paragraph3}}</p>
        </div>

        <!-- Details Heading -->
        <div style="margin-bottom: 15px;">
          <input *ngIf="isEditMode" type="text" [(ngModel)]="letterBodyText.details_heading" class="form-control"
            style="width: 100%; padding: 8px; font-weight: bold;">
          <p class="details-heading" *ngIf="!isEditMode">
            {{letterBodyText.details_heading}}
          </p>
        </div>
      </div>

      <!-- TABLE -->
      <table style="width:100%; border-collapse:collapse; margin-top:20px; margin-bottom:20px; font-size:15px;">
        <thead>
          <tr>
            <th style="border:1px solid #000; padding:12px 10px; text-align:center; height:45px;">
              बील क्रमांक
            </th>
            <th style="border:1px solid #000; padding:12px 10px; text-align:center; height:45px;">
              बील तारीख
            </th>
            <th style="border:1px solid #000; padding:12px 10px; text-align:center; height:45px;">
              बील रक्कम
            </th>
            <th style="border:1px solid #000; padding:12px 10px; text-align:center; height:45px;">
              येणे बाकी
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let inv of letter.invoices">
            <td style="border:1px solid #000; padding:12px 10px; text-align:center; height:42px;">
              {{inv.invoice_no}}
            </td>

            <td style="border:1px solid #000; padding:12px 10px; text-align:center; height:42px;">
              {{inv.invoice_date | date:'dd/MM/yyyy'}}
            </td>

            <td style="border:1px solid #000; padding:12px 10px; text-align:right; height:42px;">
              {{inv.invoice_total}}
            </td>

            <td style="border:1px solid #000; padding:12px 10px; text-align:right; height:42px;">
              {{inv.unpaid_amt}}
            </td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="2"
              style="border:1px solid #000; padding:12px 10px; text-align:right; font-weight:bold; height:45px;">
              एकूण
            </td>

            <td style="border:1px solid #000; padding:12px 10px; text-align:right; font-weight:bold; height:45px;">
              {{letter.totalInvoice}}
            </td>

            <td style="border:1px solid #000; padding:12px 10px; text-align:right; font-weight:bold; height:45px;">
              {{letter.totalBalance}}
            </td>
          </tr>
        </tfoot>
      </table>

      <!-- BANK -->
      <div class="col-7" style="padding-right: 15px;padding-top: 15px;">
        <div style="
        border: 2px solid #000;
        padding: 15px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
      ">
          <!-- Bank Details -->
          <div style="flex: 1;">
            <div style="font-weight: bold; margin-bottom: 8px; font-size: 14px;">
              Bank Details:
            </div>

            <div style="line-height: 1.6; font-size: 12px;">
              <div><strong>A/C Name:</strong> HINDUSTAN PRAKASHAN SANSTHA</div>
              <div><strong>A/C No.:</strong> 20109800154</div>
              <div><strong>IFSC No.:</strong> MAHB0000318</div>
              <div><strong>Bank Name:</strong> Bank of Maharashtra</div>
              <div><strong>Branch:</strong> Prabhadevi, Mumbai - 400025</div>
            </div>
          </div>

          <!-- QR Code -->
          <div style="margin-left: 15px;">
            <img src="../../../assets/img/brand/qr_code1.png" alt="QR Code"
              style="width: 120px; height: 120px; border: 1px solid #ddd;" />
          </div>
        </div>
      </div>

      <!-- SIGN -->
      <div style="margin-top:40px; text-align:right;font-weight:bold;">
        स्नेहांकित,<br>
        (पुस्तक विभाग प्रमुख)
      </div>

      <!-- ⭐ PAGE BREAK -->
      <div *ngIf="!last" class="page-break"></div>
      <!-- <div class="edit-controls"
        style="margin-bottom: 15px; text-align: right; padding: 10px; background-color: #f5f5f5; border-radius: 5px;">
        <button *ngIf="!isEditMode" (click)="toggleEditMode()" class="btn btn-primary" style="margin-right: 5px;">
            <i class="fa fa-edit"></i> संपादित करा (Edit)
        </button>

        <button *ngIf="isEditMode" (click)="saveLetterTemplate()" [disabled]="isSaving" class="btn btn-success"
            style="margin-right: 5px;">
            <i class="fa fa-save"></i> {{ isSaving ? 'जतन करत आहे...' : 'जतन करा (Save)' }}
        </button>

        <button *ngIf="isEditMode" (click)="toggleEditMode()" class="btn btn-secondary" style="margin-right: 5px;">
            <i class="fa fa-times"></i> रद्द करा (Cancel)
        </button>

        <button *ngIf="isEditMode" (click)="resetToDefault()" class="btn btn-warning">
            <i class="fa fa-refresh"></i> डिफॉल्ट (Reset)
        </button>
    </div> -->
    </div>
    <div class="edit-controls"
      style="margin-bottom: 15px; text-align: right; padding: 10px; background-color: #f5f5f5; border-radius: 5px;">
      <button *ngIf="!isEditMode" (click)="toggleEditMode()" class="btn btn-primary" style="margin-right: 5px;">
        <i class="fa fa-edit"></i> संपादित करा (Edit)
      </button>

      <button *ngIf="isEditMode" (click)="saveLetterTemplate()" [disabled]="isSaving" class="btn btn-success"
        style="margin-right: 5px;">
        <i class="fa fa-save"></i> {{ isSaving ? 'जतन करत आहे...' : 'जतन करा (Save)' }}
      </button>

      <button *ngIf="isEditMode" (click)="toggleEditMode()" class="btn btn-secondary" style="margin-right: 5px;">
        <i class="fa fa-times"></i> रद्द करा (Cancel)
      </button>

      <button *ngIf="isEditMode" (click)="resetToDefault()" class="btn btn-warning">
        <i class="fa fa-refresh"></i> डिफॉल्ट (Reset)
      </button>
    </div>
  </div>

</div>